import request from '@/plugins/axios'

// oauth登录
export function oauthLoginApi(data) {
  return request({
    url: `/auth/oauthLogin`,
    method: "post",
    data,
  });
}
// 获取认证服务地址
export function authUrlApi(providerName) {
  return request({
    url: `/auth/getAuthUrl?providerName=${providerName}`,
  });
}
